Vue.component('mailmodal', {
    template: `
        <div id="mailModal">
            <div class="modal fade mailModal" tabindex="-1" role="dialog" ref="mailModal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ $language.sharePub }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form @submit.prevent="sendMail">
                                <div class="row formInput">
                                    <div class="col">
                                        <input :class="{'is-invalid':errors.hasOwnProperty('email')}" type="mail" class="form-control" :placeholder="$language.toEmail" v-model="to" name="mailTo">
                                        <div class="invalid-feedback">
                                            {{ mailError }}
                                        </div>
                                    </div>
                                </div>
                                <div class="row formInput">
                                    <div class="col">
                                        {{ $language.optional }}:
                                        <textarea class="form-control" rows="5" v-model="message"></textarea>
                                    </div>
                                </div>
                                <div class="row mailSend">
                                    <div class="col-4">
                                        <button @click="sendMail" class="btn btn-primary" type="button" v-if="!sending">
                                            {{ $language.send }}
                                        </button>
                                        <button class="btn btn-primary disabled" type="button" v-else>
                                            <i class="fas fa-spinner fa-spin"></i>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="mailToast" ref="mailToast" :class="{showToast: showMailSuccess}" class="toast show">
                <div class="toast-header">
                    <strong class="mr-auto">{{ $language.sendSuccess.replace('[EMAIL]', to) }}</strong>
                    <span class="close" @click="showMailSuccess = false;"><i class="fas fa-times"></i></span>
                </div>
            </div>
        </div>
    `,
    data: function() {
        return {
            message: '',
            to: '',
            errors: [],
            showSuccess: false,
            sending: false,
            showMailSuccess: false
        };
    },


    computed: {

        mailError() {
            if (this.errors.email == 'invalid') {
                return this.$language.mailInvalid;
            } else if (this.errors.email == 'required') {
                return this.$language.mailRequired;
            }
        },

        fn() {
            return this.$store.getters.fn;
        },

        members() {
            return this.$store.getters.membersData;
        },

        member() {
            return this.members[this.$store.getters.currentMember];
        },

        pn() {
            return this.member.c_publicationnumber;
        },

        kd() {
            return this.member.c_kindcode;
        }

    },

    mounted() {


        EventBus.$on('showShare', () => {
            this.showMailModal();
        });

        $(this.$refs.copyBtn).tooltip();

        this.message = '\n--\nEmail sent on behalf of ' + this.$user.name + ' (' + this.$user.email + '). Please do not reply directly to this message.'

    },

    methods: {

        showMailModal() {
            $(this.$refs.mailModal).modal('show');
        },

        sendMail() {

            this.errors = [];
            this.sending = true;

            var params = new URLSearchParams();
            params.append('to', this.to);
            params.append('message', this.message);
            params.append('fn', this.fn);
            params.append('pn', this.pn);
            params.append('kd', this.kd);

            axios.post('?page=sendMail&action=send', params)
                .then(res => {
                    $(this.$refs.mailModal).modal('hide');
                    this.showMailSuccess = true;

                    setTimeout(() => {
                        this.showMailSuccess = false;
                        this.sending = false;
                    }, 3000);

                })
                .catch(err => {
                    this.errors = err.response.data;
                    this.sending = false;
                });

        }

    }
});
